import { format } from "date-fns";

/** Formats a value like "Feb 2, 2022, 9:41 AM"; returns "" for invalid input. */
export const formatPublishedDate = (value: string | Date): string => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  return format(date, "MMM d, yyyy, p");
};
